import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from "@src/service";
import { IGetSettingsResponse } from "./types";
import { SettingGroupEntity, SettingUnitType } from '@src/core/features/settings/entities';

export const baseSettingsApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'baseSettingsApi',
  tagTypes: ['Settings', 'Users', 'UserSettings'],
  endpoints: (builder) => ({
    getSettings: builder.query<IGetSettingsResponse, void>({
      query: () => ({
        url: '/api/v1/orders/settings',
        method: 'GET',
      }),
      providesTags: ['Settings'],
      transformResponse(group: SettingGroupEntity[]) {
        return {
          group: group,
          items: group.flatMap((g) => g.items),
        };
      },
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const units = data.items.find((item) => item.key === SettingUnitType.UNITS);
          if (typeof units !== 'undefined') {
            localStorage.setItem(SettingUnitType.UNITS, units.value);
          }
        } catch (error) {}
      }
    })
  }),
});

export const { useGetSettingsQuery } = baseSettingsApi;